export default __webpack_public_path__ + "static/lp-evergreen-desktop-8d0084f649c1568adfb241871629c0fc.webp";